import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Coverage } from "@graphql/api";

import getCoverageItemTitle from "../../../utils/getCoverageItemTitle";
import DocumentsList from "./DocumentsList";

interface Props {
  coverage: Coverage;
  residentId: string;
}

export default function DocumentsCoverageItem({ coverage, residentId }: Props) {
  return (
    <Accordion
      sx={{
        border: "none",
        borderBottom: "1px solid #e0e0e0",
        borderRadius: "0 !important",
        "&:before": {
          display: "none",
        },
      }}>
      <AccordionSummary
        sx={{
          px: 0,
          "&.Mui-expanded": {
            minHeight: 0,
          },
          "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded":
            {
              my: 2,
            },
        }}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${coverage.id}-documents-content`}
        id={`${coverage.id}-documents-header`}>
        <Typography>{getCoverageItemTitle(coverage)}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 0, py: 2 }}>
        <DocumentsList residentId={residentId} documents={coverage.documents} />
      </AccordionDetails>
    </Accordion>
  );
}
